import { render, staticRenderFns } from "./ProjectName.vue?vue&type=template&id=1b6a997e&scoped=true&"
import script from "./ProjectName.vue?vue&type=script&lang=js&"
export * from "./ProjectName.vue?vue&type=script&lang=js&"
import style0 from "./ProjectName.vue?vue&type=style&index=0&id=1b6a997e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6a997e",
  null
  
)

export default component.exports